import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const fechaCorta = (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    return m ? `${+m[3]} de ${MESES[+m[2] - 1]}` : '—';
};
const cuando = (dias) => (dias === 0 ? 'Hoy' : dias === 1 ? 'Mañana' : `En ${dias} días`);

const Pill = ({ bg, color, icon, children }) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '3px 10px', borderRadius: '999px', fontSize: '0.75rem', fontWeight: 700, background: bg, color, whiteSpace: 'nowrap' }}>
        <i className={`bi ${icon}`}></i>{children}
    </span>
);

// Cumpleañeros próximos (Pacientes). El día del cumpleaños el servicio de recordatorios les envía
// automáticamente la felicitación con el descuento; aquí se ve el estado y se puede reenviar a mano.
const CumpleanosProximos = ({ onVerPaciente }) => {
    const [dias, setDias] = useState(30);
    const [datos, setDatos] = useState(null);
    const [abierto, setAbierto] = useState(true);
    const [enviando, setEnviando] = useState(null);
    const [aviso, setAviso] = useState(null);

    const cargar = async (d = dias) => {
        try {
            const { data } = await api.get(`/api/patients/cumpleanos/?dias=${d}`);
            setDatos(data);
        } catch (e) {
            setDatos({ cumpleaneros: [], error: true });
        }
    };

    useEffect(() => { cargar(dias); }, [dias]); // eslint-disable-line react-hooks/exhaustive-deps

    const mostrarAviso = (texto, ok = true) => {
        setAviso({ texto, ok });
        setTimeout(() => setAviso(null), 5000);
    };

    const enviar = async (c) => {
        if (!window.confirm(`¿Enviar ahora la felicitación de cumpleaños a ${c.paciente} (${c.email})?`)) return;
        setEnviando(c.id);
        try {
            const { data } = await api.post(`/api/patients/${c.id}/enviar-cumpleanos/`, {});
            mostrarAviso(data.detail);
            cargar();
        } catch (e) {
            const err = e.response?.data;
            mostrarAviso(err?.detail || err?.email || 'No se pudo enviar la felicitación.', false);
        }
        setEnviando(null);
    };

    const lista = datos?.cumpleaneros || [];
    const deHoy = lista.filter(c => c.dias_faltan === 0).length;

    const estado = (c) => {
        if (c.felicitacion === 'enviado') return <Pill bg="#d1fae5" color="#065f46" icon="bi-check-circle-fill">Felicitado</Pill>;
        if (!c.email) return <Pill bg="#f3f4f6" color="#6b7280" icon="bi-envelope-slash">Sin correo</Pill>;
        if (c.felicitacion === 'error') return <Pill bg="#fee2e2" color="#991b1b" icon="bi-x-circle-fill">Error al enviar</Pill>;
        if (c.dias_faltan === 0) return <Pill bg="#fef3c7" color="#92400e" icon="bi-hourglass-split">Pendiente de envío</Pill>;
        return <Pill bg="#eff6ff" color="#1e40af" icon="bi-clock">Se enviará ese día</Pill>;
    };

    return (
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: '12px', backgroundColor: '#ffffff' }}>
            <div className="card-body p-3">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                    <button
                        onClick={() => setAbierto(!abierto)}
                        style={{ background: 'none', border: 'none', padding: 0, display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', textAlign: 'left' }}
                    >
                        <span style={{ fontSize: '1.4rem', lineHeight: 1 }}>🎂</span>
                        <span>
                            <span style={{ fontWeight: 800, color: '#111827', fontSize: '1rem' }}>Cumpleaños próximos</span>
                            <span style={{ color: '#6b7280', fontSize: '0.85rem', marginLeft: '8px' }}>
                                {datos ? `${lista.length} en los próximos ${dias} días` : 'Cargando...'}
                                {deHoy > 0 && <strong style={{ color: '#b45309' }}> · {deHoy} hoy</strong>}
                            </span>
                        </span>
                        <i className={`bi ${abierto ? 'bi-chevron-up' : 'bi-chevron-down'}`} style={{ color: '#9ca3af' }}></i>
                    </button>
                    {abierto && (
                        <div className="btn-group p-1" style={{ backgroundColor: '#f3f4f6', borderRadius: '10px' }}>
                            {[7, 30, 90].map(d => (
                                <button
                                    key={d}
                                    className="btn btn-sm"
                                    onClick={() => setDias(d)}
                                    style={{ backgroundColor: dias === d ? '#111827' : 'transparent', color: dias === d ? '#ffffff' : '#4b5563', fontWeight: 700, borderRadius: '8px', padding: '4px 12px', border: 'none', fontSize: '0.8rem' }}
                                >
                                    {d} días
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                {abierto && datos && (
                    <>
                        <div style={{ fontSize: '0.8rem', color: '#6b7280', margin: '8px 0 10px' }}>
                            El día de su cumpleaños cada paciente con correo recibe automáticamente una felicitación con un <strong>{datos.descuento ?? 10}% de descuento</strong>.
                        </div>
                        {datos.error ? (
                            <div className="text-danger" style={{ fontSize: '0.85rem' }}>No se pudo cargar la lista de cumpleaños.</div>
                        ) : lista.length ? (
                            <div className="table-responsive" style={{ maxHeight: '320px', overflowY: 'auto' }}>
                                <table className="table table-sm align-middle mb-0" style={{ fontSize: '0.85rem' }}>
                                    <thead>
                                        <tr style={{ color: '#6b7280', fontSize: '0.75rem' }}>
                                            <th className="border-0">CUÁNDO</th>
                                            <th className="border-0">PACIENTE</th>
                                            <th className="border-0">CUMPLE</th>
                                            <th className="border-0">CONTACTO</th>
                                            <th className="border-0">FELICITACIÓN</th>
                                            <th className="border-0"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lista.map(c => (
                                            <tr key={c.id} style={{ backgroundColor: c.dias_faltan === 0 ? '#fffbeb' : undefined }}>
                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                    <div style={{ fontWeight: 700, color: c.dias_faltan === 0 ? '#b45309' : '#111827' }}>{cuando(c.dias_faltan)}</div>
                                                    <div style={{ color: '#6b7280', fontSize: '0.78rem' }}>{fechaCorta(c.cumple)}</div>
                                                </td>
                                                <td>
                                                    {onVerPaciente ? (
                                                        <button onClick={() => onVerPaciente(c.id)} style={{ background: 'none', border: 'none', padding: 0, fontWeight: 700, color: '#111827', textAlign: 'left', cursor: 'pointer' }}>{c.paciente}</button>
                                                    ) : <span style={{ fontWeight: 700 }}>{c.paciente}</span>}
                                                    {c.cedula && <div style={{ color: '#6b7280', fontSize: '0.78rem' }}>{c.cedula}</div>}
                                                </td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{c.cumple_anios} años</td>
                                                <td>
                                                    <div style={{ overflowWrap: 'anywhere' }}>{c.email || <span className="text-muted">—</span>}</div>
                                                    {c.telefono && <div style={{ color: '#6b7280', fontSize: '0.78rem' }}>{c.telefono}</div>}
                                                </td>
                                                <td>{estado(c)}</td>
                                                <td className="text-end">
                                                    {c.dias_faltan === 0 && c.email && c.felicitacion !== 'enviado' && (
                                                        <button
                                                            className="btn btn-sm"
                                                            onClick={() => enviar(c)}
                                                            disabled={enviando === c.id}
                                                            style={{ backgroundColor: '#111827', color: '#fff', fontWeight: 700, borderRadius: '8px', fontSize: '0.78rem', whiteSpace: 'nowrap' }}
                                                        >
                                                            <i className="bi bi-send me-1"></i>{enviando === c.id ? 'Enviando...' : 'Enviar ahora'}
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-muted" style={{ fontSize: '0.85rem' }}>Nadie cumple años en los próximos {dias} días.</div>
                        )}
                        {(datos.sin_fecha > 0 || datos.fecha_estimada > 0) && (
                            <div style={{ background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 8, padding: '8px 12px', fontSize: '0.8rem', marginTop: 10 }}>
                                <i className="bi bi-exclamation-triangle me-1"></i>
                                {datos.sin_fecha > 0 && <>{datos.sin_fecha} paciente(s) no tienen fecha de nacimiento. </>}
                                {datos.fecha_estimada > 0 && <>{datos.fecha_estimada} tienen solo una fecha estimada por la edad. </>}
                                No recibirán felicitación hasta registrar su fecha de nacimiento real.
                            </div>
                        )}
                    </>
                )}
            </div>
            {aviso && (
                <div style={{ position: 'fixed', right: 20, bottom: 20, zIndex: 1060, padding: '12px 18px', borderRadius: 10, fontWeight: 600, boxShadow: '0 10px 25px rgba(0,0,0,0.15)', maxWidth: 420, background: aviso.ok ? '#065f46' : '#991b1b', color: '#fff' }}>
                    {aviso.texto}
                </div>
            )}
        </div>
    );
};

export default CumpleanosProximos;
